<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import UserPresenter from '@satellite/components/elements/presenters/user/UserPresenter.vue';
import { useYardTaskAttachmentEvent } from './useYardTaskAttachmentEvent';

import type { YardTaskTimelineEvent } from './types';

interface Props {
  event: YardTaskTimelineEvent;
  timezone: string;
  locale: string;
}

const { event, timezone, locale } = defineProps<Props>();

const { t } = useI18n();
const { formattedCreatedTime, user, leadIn, fileName } = useYardTaskAttachmentEvent(event, {
  timezone,
  locale
});
</script>

<template>
  <div
    class="d-flex flex-column ga-2 align-start justify-start"
    data-testid="yard-task-attachment-event">
    <div class="d-flex flex-column gap-0-5 align-start justify-start">
      <span class="d-flex flex-row flex-wrap align-center justify-start ga-1">
        <user-presenter
          v-if="user"
          class="typography-body-sm-bold text--color-text-secondary"
          :user="user"
          :display-fields="['name']" />
        <span class="typography-body-sm">{{ leadIn }}</span>
        <span class="typography-body-sm-bold text-lowercase">
          {{ t('global.timeline.attachments') }}
        </span>
      </span>
      <span v-if="formattedCreatedTime" class="typography-caption text--color-text-tertiary">
        {{ formattedCreatedTime }}
      </span>
    </div>

    <div
      v-if="fileName"
      class="typography-body-sm text--color-text-secondary"
      data-testid="yard-task-attachment-event-file-name">
      {{ fileName }}
    </div>
  </div>
</template>
